import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ListItem, ListItemButton, ListItemText } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from 'react-router-dom';
const SettingsNavigationItem = ({ to, primary, secondary }) => {
    const navigate = useNavigate();
    return (_jsx(ListItem, { children: _jsxs(ListItemButton, Object.assign({ onClick: () => navigate(to), sx: { pl: 0 } }, { children: [_jsx(ListItemText, { primary: primary, secondary: secondary }), _jsx(ChevronRightIcon, {})] })) }));
};
export default SettingsNavigationItem;
